import { useCallback, useContext, useRef } from 'react';
import { AudioContext } from 'services/contexts/AudioProvider';

const useAudio = () => {
  const { audioElement } = useContext(AudioContext);
  const whenCanPlay = useRef<Promise<void> | null>(null);
  const setSrc = useCallback(
    (src: string) => {
      if (!audioElement) {
        return;
      }
      audioElement.src = src;
      whenCanPlay.current = new Promise<void>((resolve) => {
        const onCanPlayThrough = () => {
          audioElement.removeEventListener('canplaythrough', onCanPlayThrough);
          resolve();
        };
        audioElement.addEventListener('canplaythrough', onCanPlayThrough);
      });
    },
    [audioElement]
  );

  const play = useCallback(async () => {
    if (!audioElement) {
      return;
    }

    await whenCanPlay.current;
    await audioElement.play();
  }, [audioElement]);

  const pause = useCallback(() => {
    if (!audioElement) {
      return;
    }
    audioElement.pause();
  }, [audioElement]);

  return {
    audioElement,
    setSrc,
    play,
    pause,
  };
};

export default useAudio;
